import { format } from "date-fns";
import { DATE_FORMAT, widgetType } from "constants/globals";

export const getPrefixForLs = (widgetTypeId: string) => {
  switch (widgetTypeId) {
    case widgetType.bmvStocks:
      return InstrumentPrefixes.BmvStockInstrumentPrefixForLS;
    case widgetType.currencies:
      return InstrumentPrefixes.CurrencyInstrumentPrefixForLS;
    case widgetType.indexes:
      return InstrumentPrefixes.IndexInstrumentPrefixForLS;
    case widgetType.generalIndicators:
      return InstrumentPrefixes.GeneralIndicatorsInstrumentPrefixForLS;
    case widgetType.bmvEquitySIC:
      return InstrumentPrefixes.BmvEquitySicInstrumentPrefixForLS;
    case widgetType.SICBIVA:
      return InstrumentPrefixes.SICBIVAInstrumentPrefixForLS;
    case widgetType.nyseNasdaq:
      return InstrumentPrefixes.SICBIVAInstrumentPrefixForLS;
    default:
      return InstrumentPrefixes.BmvStockInstrumentPrefixForLS;
  }
};

export const formatInstrumentForLS = (
  instrument: string,
  widgetTypeId: string,
  marketType: number,
  valueType: number,
  stockExchange: number
): string => {
  let subscriptionFormat;

  if (!instrument) {
    return "";
  }
  if (marketType !== undefined && valueType !== undefined && stockExchange !== undefined) {
    subscriptionFormat = `${marketType}.${valueType}.${stockExchange}.${instrument
      .replace("*", EncodedCharacters.ASTERISK)
      .replace("&", EncodedCharacters.AMPERSAND)
      .replace("-", EncodedCharacters.DASH)
      .replace(/\s/g, EncodedCharacters.SPACE)
      .replace(".BI", "")}`;
  } else {
    subscriptionFormat =
      (widgetTypeId ? getPrefixForLs(widgetTypeId) : "") +
      instrument
        .replace("*", EncodedCharacters.ASTERISK)
        .replace("&", EncodedCharacters.AMPERSAND)
        .replace("-", EncodedCharacters.DASH)
        .replace(/\s/g, EncodedCharacters.SPACE)
        .replace(".BI", "");
  }
  return subscriptionFormat;
};

const InstrumentPrefixes = {
  BmvStockInstrumentPrefixForApi: "1/12576/0/",
  BmvStockInstrumentPrefixForLS: "1.12576.0.",
  BmvEquitySicInstrumentPrefixForApi: "1/12609/0/",
  BmvEquitySicInstrumentPrefixForLS: "1.12609.0.",
  CurrencyInstrumentPrefixForApi: "4096/50/25/",
  CurrencyInstrumentPrefixForLS: "4096.50.25.",
  SICBIVAInstrumentPrefixForLS: "2.20.1.",
  SICBIVAInstrumentPrefixForApi: "2/20/1/",
  GeneralIndicatorsInstrumentPrefixForLS: "32768.1.1000.",
  IndexInstrumentPrefixForApi: "64/1/0/",
  IndexInstrumentPrefixForLS: "64.1.0.",
  NyseNasdaqInstrumentPrefixForApi: "32/2/21/",
  NyseNasdaqInstrumentPrefixForLS: "32.2.21.",
  InstrumentPrefixForLSPositionFields: "P.",
};

const EncodedCharacters = {
  ASTERISK: "K__42__",
  AMPERSAND: "K__38__",
  DASH: "K__45__",
  SPACE: "K__32__",
};

export const formatInstrumentWithPositionFieldsForLS = (
  instrument: string,
  marketType: number,
  valueType: number,
  stockExchange: number
) =>
  InstrumentPrefixes.InstrumentPrefixForLSPositionFields +
  formatInstrumentForLS(instrument, "", marketType, valueType, stockExchange);

export const comparer = (otherArray: Array<any>) => (current: any) => {
  return (
    otherArray.filter((other) => {
      return other.descripcion === current.descripcion;
    }).length === 0
  );
};

export const getJulianDateStringFromDate = (dateJulian: number): string => {
  let date = new Date();

  if (!dateJulian) {
    // eslint-disable-next-line no-param-reassign
    dateJulian = 0;
  }
  date = new Date(1960, 12, 31);
  date = new Date(date.setDate(dateJulian));

  let dateMonth: number | string = date.getMonth() + 1;
  let dateDay: number | string = date.getDate();
  const dateYear: number | string = date.getFullYear();

  if (dateMonth < 10) dateMonth = `0${dateMonth}`;
  if (dateDay < 10) dateDay = `0${dateDay}`;

  return `${dateDay}-${dateMonth}-${dateYear}`;
};

export const getDateByString = (date: string, formatValue?: string): string => {
  const dateSplit = String(date).split("-");

  if (!dateSplit) {
    return date;
  }

  if (dateSplit.length < 3) {
    return date;
  }

  return format(
    new Date(Number(dateSplit[2]), Number(dateSplit[1]) - 1, Number(dateSplit[0])),
    formatValue || DATE_FORMAT.toLocaleLowerCase()
  );
};
